import { createContainer } from 'unstated-next'
import usePageNav from '../hooks/usePageNav'

const PageNavContainer = createContainer(usePageNav)

PageNavContainer.displayName = `PageNavContainer`

export default PageNavContainer
